import { Flex, Text } from '@approvalmax/ui/src/components';
import { intl } from '@approvalmax/utils';
import { domain } from 'modules/data';

import { messages } from './POFooter.messages';
import { POFooterProps } from './POFooter.types';

export const POFooter = (props: POFooterProps) => {
    const { request, lineNumber, matchingLines } = props;

    if (request.integrationCode !== domain.IntegrationCode.NetSuitePO) {
        return null;
    }

    const sourceLine = [...request.details.expenseLines, ...request.details.itemLines].find(
        (line) => line.lineNumber === lineNumber
    );

    const matchedLinesAmount = matchingLines.reduce(
        (acc, { line, documentLineNumber }) => acc + (documentLineNumber === lineNumber ? line?.grossAmount ?? 0 : 0),
        0
    );

    const remainingBalance = (sourceLine?.grossAmount ?? 0) - matchedLinesAmount;

    return (
        <Flex>
            <Text font='label' fontSize='small'>
                {messages.remainingBalance({
                    remainingBalance: intl.formatCurrency(remainingBalance, request.currency),
                    strong: (chunks) => (
                        <Text font='label' fontSize='small' fontWeight='bold' as='span'>
                            {chunks}
                        </Text>
                    ),
                })}
            </Text>
        </Flex>
    );
};

POFooter.displayName = 'POFooter';
